import styled from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { CONTAINER_MAX } from '@/constants/breakpoints';
import { flexBetween, flexCenterAligned, flexColumn } from '@/styles/common';

export const ModalHeader = styled.div<{ $isBack?: boolean }>`
  width: 100%;
  ${flexBetween};
  flex-shrink: 0;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  height: ${({ $isBack }) => ($isBack ? '143px' : '109px')};
  padding: 0 40px;
  z-index: 1;

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    padding: 0 30px;
    position: relative;
    height: ${({ $isBack }) => ($isBack ? '97px' : '61px')};
  }

  @media (max-width: ${CONTAINER_MAX.mobileL}) {
    padding: 0 22.5px;
  }
`;

export const ModalCloseIconButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  width: 100%;
  height: 100%;
  max-width: 15px;
  max-height: 15px;
  ${flexCenterAligned}
`;

export const ModalHeaderSection = styled.div`
  width: 100%;
  ${flexColumn};
  gap: 20px;
  padding-block-end: 15px;

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    padding: 0;
  }
`;

export const ModalBackButton = styled.button`
  width: 100%;
  height: 100%;
  max-width: 24px;
  max-height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  ${flexCenterAligned};
`;

export const ModalTitle = styled(Typography).attrs({
  variant: 'h1'
})`
  color: var(--textAndLabels-main);

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    font-size: 18px;
  }
`;
